import { createSelector } from "@reduxjs/toolkit";

import { REQUEST_STATUSES, ROLES } from "@/constants/index.js";

const initialState = {
  members: [],
  noResults: false,
  status: REQUEST_STATUSES.IDLE,
  err: null,
};

export const membersSelector = (propertyId) =>
  createSelector(
    (state) => state.members[propertyId],
    (members) => {
      return {
        ...initialState,
        ...members,
        noResults: members?.members?.length === 0,
      };
    },
  );

export const salespersonMembersSelector = (propertyId) =>
  createSelector(
    (state) => state.members[propertyId],
    (members) => {
      return {
        ...initialState,
        members: members?.members?.filter((member) => member.memberRole.title === ROLES.SALESPERSON) || [],
        noResults: members?.members?.length === 0,
      };
    },
  );
